import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  // ### New public view and visitor endpoints
  async getPublicDebate(publicLinkId) {
    return await picador.get('getPublicDebate', xhrPath.publicDebate({ publicLinkId }));
  },
  async getPublicDebateDoc(publicLinkId) {
    return await picador.get('getPublicDebateDoc', xhrPath.publicDebateDoc({ publicLinkId }));
  },
  async createVisitor(visitorData) {
    return await picador.post('createVisitor', xhrPath.visitor({}), { visitors: visitorData });
  },
  async getPublicDocumentDetails(documentID) {
    return await picador.get(
      'getPublicDocumentDetails',
      `${xhrPath.publicDocument({ documentID })}/details`
    );
  },
  async getPublicDebateStatus(documentID, visitorID) {
    return await picador.get(
      'getPublicDebateStatus',
      xhrPath.publicDocument({ documentID }) + '/status' + '?visitor_id=' + visitorID
    );
  },
  async getPublicCitations(documentID) {
    return await picador.get(
      'getPublicCitations',
      xhrPath.publicDocument({ documentID }) + '/citations'
    );
  },
  async getPublicDebateNextState(documentID) {
    return await picador.get(
      'getPublicDebateNextState',
      xhrPath.publicDocument({ documentID }) + '/next_state'
    );
  },
  async addAnnotationLike(likes) {
    return await picador.post('addAnnotationLike', 'api/v2/likes', { likes });
  },
  async deleteAnnotationLike(id) {
    return await picador.delete('deleteAnnotationLike', 'api/v2/likes/' + id);
  },

  // ###
  async addPublicLinkShare(publicLinkId, documentId, annotationId, socialNetwork, visitorId) {
    return await picador.post('addPublicLinkShare', xhrPath.share() + '/save', {
      visitorId,
      publicLinkId,
      documentId,
      annotationId,
      socialNetwork,
    });
  },

  async generatePostImage(publicLinkId, annotationId, socialNetwork) {
    return await picador.post('generatePostImage', xhrPath.share() + '/image', {
      publicLinkId,
      annotationId,
      socialNetwork,
    });
  },
};
